import React, { useEffect } from 'react';

const API_KEY = "ApiKey-05ef11fd-e6d6-4355-ae03-3876b7661796";

function WatsonAPI() {
  useEffect(() => {
    getToken()
      .then((tokenResponse) => {
        const payload =
          '{"input_data": [{"fields": [array_of_input_fields], "values": [array_of_values_to_be_scored, another_array_of_values_to_be_scored]}]}';
        const scoring_url =
          "https://us-south.ml.cloud.ibm.com/ml/v4/deployments/drugprediction/predictions?version=2021-05-01";
        return apiPost(scoring_url, tokenResponse.access_token, payload);
      })
      .then((parsedPostResponse) => {
        console.log("Scoring response");
        console.log(parsedPostResponse);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  function getToken() {
    const url = "https://iam.cloud.ibm.com/identity/token";
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json",
      },
      body: `grant_type=urn:ibm:params:oauth:grant-type:apikey&apikey=${API_KEY}`,
    };

    return fetch(url, requestOptions)
      .then((response) => response.json())
      .catch((error) => {
        throw new Error("Error fetching token: " + error.message);
      });
  }

  function apiPost(scoring_url, token, payload) {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      body: payload,
    };

    return fetch(scoring_url, requestOptions)
      .then((response) => response.json())
      .catch((error) => {
        throw new Error("Error making API call: " + error.message);
      });
  }

  return <div>IBM Watson API Call</div>;
}

export default WatsonAPI;
